import classNames from 'classnames'
import { getLink } from '@helpers/env'
import { ProductCardProduct } from './ProductCard/types'
import ProductCard from './ProductCard'
import styles from './styles.module.scss'

export type ProductSliderProduct = ProductCardProduct

type ProductsSliderProps = {
  products: ProductCardProduct[]
  onProductLinkClick: (args: ProductCardProduct) => void
}

function ProductsSlider({ products, onProductLinkClick }: ProductsSliderProps) {
  const hasLessThanFourProducts = products?.length < 4
  const hasMoreThanFourProducts = products?.length > 4
  const productSliderCLasses = classNames(styles.ProductsSlider__products, {
    [styles.center]: hasLessThanFourProducts,
    [styles.thinDivider]: hasMoreThanFourProducts
  })
  return (
    <>
      {!!products?.length && (
        <ul className={productSliderCLasses}>
          {products.map(product => {
            return (
              <li key={product.id}>
                <a
                  className={styles.ProductsSlider__productLink}
                  href={getLink(`/products/${product.handle}`)}
                  aria-label={`Shop ${product.title} ${product.byline}`}
                  onClick={() => onProductLinkClick(product)}
                >
                  <ProductCard
                    id={product.id}
                    tags={product.tags}
                    title={product.title}
                    byline={product.byline}
                    price={product.price}
                    fullPrice={product.fullPrice}
                    image={product.image}
                    imageHover={product.imageHover}
                    className={styles.ProductsSlider__card}
                  />
                </a>
              </li>
            )
          })}
        </ul>
      )}
    </>
  )
}

export default ProductsSlider
